<template>
  <CallPlanningLayout>
    <h2>Call Planning Brands</h2>
    <DataTable class="mt-3" :data="data" :perPage="25" noSearch>
      <template #menu>
        <div class="hvh-flex align-center">
          <v-btn flat class="hvh-btn hvh-btn--secondary" @click="addBrand" v-if="isAdmin">Add</v-btn>
        </div>
      </template>
      <template #head>
        <tr>
          <Th prop="name" sort>Name</Th>
          <Th prop="role" sort>Role</Th>
          <Th prop="regions" sort>Regions</Th>
          <Th prop="territories" sort>Territories</Th>
          <th>Reps</th>
          <th v-if="isAdmin">Admin</th>
        </tr>
      </template>
      <template #body="{ item }">
        <tr>
          <td>
            <router-link :to="item.url">{{ item.name }}</router-link>
          </td>
          <td>{{ item.role }}</td>
          <td>{{ item.regions || '-' }}</td>
          <td>{{ item.territories || '-' }}</td>
          <td class="text-center">
            <router-link :to="item.usersUrl" v-if="item.usersUrl">
              <v-icon>mdi-account-supervisor</v-icon>
            </router-link>
          </td>
          <td class="text-center" v-if="isAdmin"><v-icon @click="$router.push({ name: 'callPlanningAdmin', params: { brandId: item.id } })">mdi-pencil</v-icon></td>
        </tr>
      </template>
    </DataTable>
    <Loader v-if="!data || isLoading" />
  </CallPlanningLayout>
</template>

<script>
import axios from '../../axios';
import CallPlanningAddBrand from '../../components/callPlanning/CallPlanningAddBrand.vue';
import CallPlanningLayout from '../../components/callPlanning/CallPlanningLayout.vue';
import DataTable from '../../components/common/dataTable/DataTable.vue';
import Th from '../../components/common/dataTable/Th.vue';
import { createFormData, errorDebug, } from '../../libraries/common';
export default {
  components: { DataTable, Th, CallPlanningLayout, },
  title: 'Call Planning',
  data() {
    return {
      data: null,
      isLoading: false,
    };
  },
  computed: {
    isAdmin() {
      return this.$store.state.user.isMainAdmin || this.getFlag('DAS-1091');
    },
  },
  methods: {
    getData() {
      this.isLoading = true;
      axios.get(`/api/CallPlanning/Brands`)
        .then(({ data }) => this.data = [
          ...data.managers.map(f => ({
            ...f,
            role: 'Manager',
            regions: f.regions.join(', '),
            territories: f.territories.join(', '),
            url: { name: 'callPlanningManager', params: { brandId: f.id } },
            usersUrl: { name: 'callPlanningManagerUsers', params: { brandId: f.id } },
          })),
          ...data.users.map(f => ({
            ...f,
            role: 'User',
            regions: f.regions.join(', '),
            territories: f.territories.join(', '),
            url: { name: 'callPlanningUser', params: { brandId: f.id } }
          })),
          ...(data.brands || []).map(f => ({ ...f, role: 'Admin', url: { name: 'callPlanningAdmin', params: { brandId: f.id } } })),
        ])
        .catch(errorDebug)
        .then(() => this.isLoading = false);
    },
    addBrand() {
      this.$confirm('Add Brand', null,
        {
          optionComponent: CallPlanningAddBrand,
          option: {},
        })
        .then(({ name, targetListFile, zipToTerritoryFile, }) => {
          this.isLoading = true;
          axios.post('/api/CallPlanning/Brands', createFormData({ name, targetListFile, zipToTerritoryFile, }))
            .then(({ data }) => this.$router.push({ name: 'callPlanningAdmin', params: { brandId: data.id } }))
            .catch(errorDebug)
            .then(() => this.isLoading = false);
        })
        .catch(() => null);
    },
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisCallPlanning'] = this;
    this.getData();
  },
}
</script>

<style lang="scss" scoped>
.link {
  color: #002f6c;
  border-bottom: 1px solid #002f6c;
  cursor: pointer;
}
</style>